export default __webpack_public_path__ + "static/media/hbs-k-banner-2.22d4a12f.jpg";